import React from 'react';
import { i18n } from 'config/locales';
import {
  CommonRequired, OnError, OnUpdate
} from 'types/props';
import { ForeignTravelItemModel } from 'forms/sections/foreign/travel/types';
import CheckboxGroup from 'components/Form/CheckboxGroup';
import Checkbox from 'components/Form/Checkbox';
import { CheckboxModel } from 'forms/shared/types';
import { ErrorCode } from '@redux/modules/application/reducers/error';
import Radio from 'components/Form/Radio';
import RadioGroup from 'components/Form/RadioGroup';
import ValidationElement, {
  ValidationElementProps,
} from '../../../Form/ValidationElement/ValidationElement';

interface Props extends Partial<ForeignTravelItemModel['Purpose']>, ValidationElementProps {
  onUpdate?: OnUpdate<ForeignTravelItemModel['Purpose']>
  onError?: OnError
  required?: CommonRequired
  className?: string
  attribute?: string
  requireSingleSelection?: boolean
}

export default class TravelPurpose extends ValidationElement<Props> {
  static defaultProps: {
    values: string[],
    onUpdate: (queue: ForeignTravelItemModel['Purpose']) => void,
    onError: (value: string, arr: ErrorCode[]) => ErrorCode[],
    requireSingleSelection: false,
  };

  update = (response: CheckboxModel) => {
    const selected = response.value;
    let list = [...(this.props.values || [])];

    if (!this.props.requireSingleSelection) {
      if (list.includes(selected)) {
        list.splice(list.indexOf(selected), 1);
      } else {
        list.push(selected);
      }
    } else {
      list = [selected];
    }

    this.props.onUpdate?.({ values: list });
  };

  render() {
    return this.props.requireSingleSelection ? (
      <RadioGroup
        attribute={this.props.attribute}
        className={`travel-purpose option-list option-list-vertical ${
          this.props.className || ''
        }`.trim()}
        onError={this.props.onError}
        required={this.props.required}
        selectedValue={this.props.values?.[0] || ''}
      >
        <Radio
          name="purpose-business"
          label={i18n.t('foreign.travel.label.business')}
          value="Business"
          className="purpose-business"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="purpose-volunteer"
          label={i18n.t('foreign.travel.label.volunteer')}
          value="Volunteer"
          className="purpose-volunteer"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="purpose-education"
          label={i18n.t('foreign.travel.label.education')}
          value="Education"
          className="purpose-education"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="purpose-tourism"
          label={i18n.t('foreign.travel.label.tourism')}
          value="Tourism"
          className="purpose-tourism"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="purpose-conference"
          label={i18n.t('foreign.travel.label.conference')}
          value="Conference"
          className="purpose-conference"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="purpose-family"
          label={i18n.t('foreign.travel.label.family')}
          value="Family"
          className="purpose-family"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="purpose-other"
          label={i18n.t('foreign.travel.label.other')}
          value="Other"
          className="purpose-other"
          onUpdate={this.update}
          onError={this.props.onError}
        />
      </RadioGroup>
    ) : (
      <CheckboxGroup
        attribute={this.props.attribute}
        className={`travel-purpose option-list option-list-vertical ${
          this.props.className || ''
        }`.trim()}
        onError={this.props.onError}
        required={this.props.required}
        selectedValues={this.props.values || []}
      >
        <Checkbox
          name="purpose-business"
          label={i18n.t('foreign.travel.label.business')}
          value="Business"
          className="purpose-business"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="purpose-volunteer"
          label={i18n.t('foreign.travel.label.volunteer')}
          value="Volunteer"
          className="purpose-volunteer"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="purpose-education"
          label={i18n.t('foreign.travel.label.education')}
          value="Education"
          className="purpose-education"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="purpose-tourism"
          label={i18n.t('foreign.travel.label.tourism')}
          value="Tourism"
          className="purpose-tourism"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="purpose-conference"
          label={i18n.t('foreign.travel.label.conference')}
          value="Conference"
          className="purpose-conference"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="purpose-family"
          label={i18n.t('foreign.travel.label.family')}
          value="Family"
          className="purpose-family"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Checkbox
          name="purpose-other"
          label={i18n.t('foreign.travel.label.other')}
          value="Other"
          className="purpose-other"
          onUpdate={this.update}
          onError={this.props.onError}
        />
      </CheckboxGroup>
    );
  }
}
